import { POI_TYPES } from '../../constants/poiTypes';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../config/firebase';

export const createGeoJSONExport = async (survey) => {
  try {
    // Fetch POIs and routes
    const [pois, routes] = await Promise.all([
      fetchPOIs(survey.id),
      fetchRoutes(survey.id)
    ]);

    // Create features array with individual POIs
    const features = [];

    // Add POIs as individual features
    pois.forEach(poi => {
      const poiType = POI_TYPES[poi.type];
      features.push({
        type: 'Feature',
        properties: {
          id: poi.id,
          type: poi.type,
          name: `${poiType?.prefix || 'POI'}-${poi.id}`,
          notes: poi.notes || '',
          measurements: poi.measurements || [],
          photos: poi.photos || [],
          elevation: poi.elevation,
          address: poi.address,
          contacts: poi.contacts || [],
          createdAt: poi.createdAt,
          updatedAt: poi.updatedAt,
          style: {
            color: poiType?.color,
            prefix: poiType?.prefix,
            icon: poiType?.icon?.name
          }
        },
        geometry: {
          type: 'Point',
          coordinates: [poi.coordinates.longitude, poi.coordinates.latitude]
        }
      });
    });

    // Add routes
    routes.forEach(route => {
      features.push({
        type: 'Feature',
        properties: {
          type: 'Route',
          id: route.id,
          name: route.name,
          style: {
            color: route.color || '#3B82F6',
            width: 3,
            opacity: 0.8
          }
        },
        geometry: {
          type: 'LineString',
          coordinates: route.trackPoints.map(point => [
            point.longitude,
            point.latitude
          ])
        }
      });
    });

    // Create the main GeoJSON object
    const geojson = {
      type: 'FeatureCollection',
      properties: {
        name: survey.name,
        description: survey.description,
        created: survey.createdAt,
        updated: survey.updatedAt,
        customer: survey.customerName,
        status: survey.status,
        poiTypes: Object.entries(POI_TYPES).reduce((acc, [type, config]) => ({
          ...acc,
          [type]: {
            color: config.color,
            prefix: config.prefix,
            icon: config.icon?.name
          }
        }), {})
      },
      features
    };

    return JSON.stringify(geojson, null, 2);
  } catch (error) {
    throw new Error(`Failed to create GeoJSON: ${error.message}`);
  }
};

async function fetchPOIs(surveyId) {
  const poisRef = collection(db, 'pois');
  const poisQuery = query(poisRef, where('surveyId', '==', surveyId));
  const snapshot = await getDocs(poisQuery);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
}

async function fetchRoutes(surveyId) {
  const routesRef = collection(db, 'routes');
  const routesQuery = query(routesRef, where('surveyId', '==', surveyId));
  const snapshot = await getDocs(routesQuery);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
}